import { Block } from "@components/block";
import { Button } from "@components/button";
import { EmptyState } from "@components/empty-state";
import { FlexLoader } from "@components/loader";
import { useDevices } from "@features/device";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Device } from "./device";
import styles from "./devices.module.scss";

export const Devices = () => {
  const navigate = useNavigate();

  const { state, getDevices } = useDevices();

  useEffect(() => {
    getDevices({ limit: 10, page: 1 });
  }, [getDevices]);

  return (
    <Block className={styles.devices}>
      <h3 className={styles.title}>Подключенные устройства</h3>

      {state.loading && !state.ids ? (
        <FlexLoader />
      ) : !state.ids?.length ? (
        <EmptyState
          text="Нет подключенных устройств"
          className={styles.empty}
        />
      ) : (
        state.ids.map((deviceId) => (
          <Device
            key={deviceId}
            deviceId={deviceId}
            onClick={() => navigate(`devices/${deviceId}`)}
          />
        ))
      )}

      <Button
        type="outline"
        className={styles.button}
        onClick={() => navigate("devices")}
      >
        Подробнее
      </Button>
    </Block>
  );
};
